import apiClient from "../libs/axios";
import { apiUrl } from "../constans";

const base = `${apiUrl}/v2/wasi`;

const wasi = {
    namespaced: true,

    state: {
        credentials: { connected: false },
        importStatus: { status: 'never' },
    },

    mutations: {
        setCredentials(state, credentials) {
            state.credentials = credentials || { connected: false };
        },
        setImportStatus(state, importStatus) {
            state.importStatus = importStatus || { status: 'never' };
        },
    },

    actions: {
        // POST /v2/wasi/test-connection { user_id, id_company, wasi_token }
        //   -> data: { valid, company_name, total_properties }
        //   400/403 -> data: { valid: false, code: 'credentials'|'plan'|'unreachable' }
        storeTestConnectionWasi(_, data) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${base}/test-connection`, data)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error));
            });
        },

        // POST /v2/wasi/credentials { user_id, id_company, wasi_token, state_inmueble? }
        // state_inmueble: id de inmuebles_states, 2 Activo (def.) | 3 Eliminado -> estado
        // con el que entran los inmuebles NUEVOS en el CRM.
        // El backend revalida contra Wasi antes de guardar.
        storeCredentialsWasi({ commit }, data) {
            return new Promise((resolve, reject) => {
                apiClient.post(`${base}/credentials`, data)
                    .then(response => {
                        commit('setCredentials', { connected: true, ...(response.data.data || {}) });
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },

        // GET /v2/wasi/credentials?user_id= -> data: { connected: true|false, ... }
        storeGetCredentialsWasi({ commit }, userId) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${base}/credentials`, { params: { user_id: userId } })
                    .then(response => {
                        commit('setCredentials', response.data.data || { connected: false });
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },

        // DELETE /v2/wasi/credentials?user_id= -> no borra los inmuebles ya importados
        storeDisconnectWasi({ commit }, userId) {
            return new Promise((resolve, reject) => {
                apiClient.delete(`${base}/credentials`, { params: { user_id: userId } })
                    .then(response => {
                        commit('setCredentials', { connected: false });
                        commit('setImportStatus', { status: 'never' });
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },

        // POST /v2/wasi/import { user_id, limit? } -> 202 data: { import_id, status, total_estimated }
        //   limit es solo para pruebas: procesa esa cantidad y no marca eliminados.
        //   409 -> data: { import_id, status } (ya hay una en curso, no es error para la UI)
        storeRunImportWasi(_, { userId, limit = null } = {}) {
            const body = { user_id: userId };
            if (limit) body.limit = limit;
            return new Promise((resolve, reject) => {
                apiClient.post(`${base}/import`, body)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error));
            });
        },

        // GET /v2/wasi/import-status?user_id=[&import_id=] -> progreso para el polling
        storeImportStatusWasi({ commit }, { userId, importId = null } = {}) {
            const params = { user_id: userId };
            if (importId) params.import_id = importId;
            return new Promise((resolve, reject) => {
                apiClient.get(`${base}/import-status`, { params })
                    .then(response => {
                        commit('setImportStatus', response.data.data || { status: 'never' });
                        resolve(response.data);
                    })
                    .catch(error => reject(error));
            });
        },
    },
};

export default wasi;
